
import React, { useState, useEffect } from 'react';
import GridItem from '../components/GridItem';
import {
    useSceneStore,
  } from '../store'
  import { useMediaQuery } from 'react-responsive'
import { mediaQueries } from '../config'
import Carousel from '../components/Carousel'


export default function BSCawards() {
  const [position, setPosition] = useState(0);
  const [showIntroPanel, setShowIntroPanel] = useState(false)

  const { setCursorActive, setFeatured, setModalState, setDomRef, setEvents,setMode,setScene, setScrollPos, setBookState, setTopic, setHomeMessage, setBkgdColor, setCharacter, setTalk, setShuffled, setShowBug, setContentLayout, setBookIndex, setBookOtherIndex,setLoaded } = useSceneStore(state => state.actions)
  const isMobile = useMediaQuery({ query: mediaQueries.mobile })

  function setCursor(msg, boo){
    setCursorActive(boo)
    setTopic(msg)
  }

  useEffect(() => {

  }, []);



  return (
    <div className="bsc-rules-container">

        <hr />
        <h2 style={{marginBottom: 0}}>BOOK SONG CHALLENGE 2025</h2>
        <p className="bsc26-intro-text">    
        Check out our winners from last year for great examples of how to create your own Book Song 
        </p>

        {/*
        <p style={{textAlign: "center", outline: "1px solid #ffe70e", maxWidth: "800px", margin: "10px auto", padding: "20px 10px", color: "#ffe70e", textShadow: "1px 1px 4px #18b089"}}>The 7th Annual Book Song Challenge is coming in May 2026 with an all new format! Check back in April for more details...</p>


        <p style={{textAlign: "center", maxWidth: "800px", margin: "20px auto 40px"}}>
        Thanks to all who spread the word about the Book Song Challenge 2025 contest, and the 124 wonderful kids who entered. Appreciating the families, teachers, counselors, principals, and librarians who worked hard all year and shared lots of books! We can’t wait til #BookSong26.</p>
        */}
{/*
        <div className="bscoverlay-insta" >
             
             <Carousel 
               feedId="syo25Gnfvppkz6W2yXBh"  
               setShowIntroPanel={setShowIntroPanel}
               setCursor={setCursor}
               idx={1}
               />

         </div>
         */}
         

        <div style={{ width: "100%", maxWidth: "800px", margin: "20px auto 5px"}}>

           
            <a href="https://www.instagram.com/p/DJch5xkxBYM/" target="_blank">
        <img style={{width: "100%"}} src="/assets/images/BSC25_WinnersVideo_Website.png" alt="Book Song Challenge 2025" />
        </a>
        </div>

        <p className="bsc26-intro-text">    
        Visit our <a href="https://www.instagram.com/waypastbooks/" target="_blank">Instagram page</a> to see all entries and winners from the past six years! 
        </p>




      

        <div className="bsc-date-blocks">

          <div className="date-block">
            <h3 style={{textAlign: "center", width: "100%"}}>Congratulations to our 2025 Grand Prize Winners!!!</h3>
       
          </div>

        </div>

       
             
             
     
        <div className="bsc-winners-grid">
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJry8CzpaXq/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/1.png'}
                            alt={"Addie"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJrzqzqJuKX/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/2.png'}
                            alt={"Ava, Sophia,and Miranda"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr0iZwp6NQ/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/3.png'}
                            alt={"Chase, Evan and Dominic"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr17Y_pA32/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/4.png'}
                            alt={"Danielle"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr2n_ZJNhh/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/5.png'}
                            alt={"Claire and Andrew"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr29IiJnuZ/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/6.png'}
                            alt={"Cruz"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr3cqzptYO/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/7.png'}
                            alt={"E"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr7h9IJxum/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/8.png'}
                            alt={"Henry"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr8mqSp6Td/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/9.png'}
                            alt={"Johnny"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr9SL6JDLI/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/10.png'}
                            alt={"Lena"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr9wMgJosh/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/11.png'}
                            alt={"LB"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr-fqLpcuU/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/12.png'}
                            alt={"Olivia and Sive"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr-6E-JkYj/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/13.png'}
                            alt={"Stella and Olivia"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr_Quwpe5l/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/14.png'}
                            alt={"Taylor and Nora"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/reel/DJr_4rmpfu_/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc25/15.png'}
                            alt={"Theo"}
                            
                        />
                    </div>
                </a>
        </div>
       
     {/*
        <h3>The Winners Have Received</h3>
        <p style={{textAlign: 'center'}}>A <b>$1,000 Book Gift Card</b> for their school or library!<br />A <b>$75 Book Gift Card</b> for themselves!
         
        </p>
      

        <div className="green clickable" style={{
                    borderRadius: '15px',
                    overflow: 'hidden',
                    height: '315px',
                    outline: '20px solid #0b5542',
                    margin: '60px 0px 30px'
                }}>
                        <iframe width={isMobile ? '300' : '560'} height="315" src="https://www.youtube.com/embed/Mzy1FQ-ZUhI?si=X7hqCiAYz3W8uV_v" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      
                </div>

      */}
       
  
    </div>
  );
}